export default __webpack_public_path__ + "static/media/alback.51db184e.png";